import { render, staticRenderFns } from "./BodyCostsAnalysis.vue?vue&type=template&id=4bf8547b&scoped=true"
import script from "./BodyCostsAnalysis.vue?vue&type=script&lang=js"
export * from "./BodyCostsAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodyCostsAnalysis.vue?vue&type=style&index=0&id=4bf8547b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8547b",
  null
  
)

export default component.exports